import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Button,
  Theme,
  makeStyles,
  createStyles,
  DialogClassKey,
} from "@material-ui/core";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleRoot: {
      padding: theme.spacing(1),
    },
    titleText: {
      fontSize: "0.9rem",
      margin: theme.spacing(1),
    },
    contentRoot: {
      padding: "0.25rem",
      margin: 0,
    },
    contentText: {
      lineHeight: "1.1rem",
      padding: theme.spacing(2),
    },
  })
);

interface Props {
  // dialog
  open: boolean;
  title: string;
  maxWidth?: "lg" | "md" | "sm" | "xl" | "xs" | false;
  dialogClasses?: Partial<Record<DialogClassKey, string>>; // ex) dialogClasses={{ paper: classes.dialogPaper }}
  disableBackdropClick?: boolean;
  disableEscapeKeyDown?: boolean;
  // ok
  okLabel?: string;
  okVariant?: "text" | "outlined" | "contained";
  okColor?: "default" | "inherit" | "primary" | "secondary";
  okSize?: "small" | "medium" | "large";
  okAutofocus?: boolean;
  onOk?: () => void;
  // cancel
  cancelLabel?: string;
  cancelVariant?: "text" | "outlined" | "contained";
  cancelColor?: "default" | "inherit" | "primary" | "secondary";
  cancelSize?: "small" | "medium" | "large";
  cancelAutofocus?: boolean;
  onCancel?: () => void;
  // children
  children?: React.ReactNode;
}

/** 確認ダイアログ */
export function ConfirmDialog(props: Props) {
  const classes = useStyles();

  const {
    open,
    title,
    maxWidth,
    dialogClasses,
    disableBackdropClick,
    disableEscapeKeyDown,
    okLabel,
    okVariant,
    okColor,
    okSize,
    onOk,
    cancelLabel,
    cancelVariant,
    cancelSize,
    onCancel,
    children,
  } = props;

  //--------------------
  // コンポーネント
  return (
    <Dialog
      maxWidth={maxWidth || "lg"}
      scroll="paper"
      open={open}
      disableBackdropClick={disableBackdropClick}
      disableEscapeKeyDown={disableEscapeKeyDown}
      classes={dialogClasses}
    >
      {title && (
        <DialogTitle className={classes.titleRoot}>
          <span className={classes.titleText}>{title}</span>
        </DialogTitle>
      )}
      <DialogContent className={classes.contentRoot}>
        <DialogContentText className={classes.contentText} component="div">
          {children}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant={cancelVariant}
          size={cancelSize || "small"}
          onClick={() => {
            if (onCancel) {
              onCancel();
            }
          }}
        >
          {cancelLabel || "キャンセル"}
        </Button>
        <Button
          variant={okVariant}
          color={okColor || "primary"}
          size={okSize || "small"}
          style={{ width: "5rem" }}
          onClick={() => {
            if (onOk) {
              onOk();
            }
          }}
        >
          {okLabel || "　OK　"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
